import { render, staticRenderFns } from "./tabelasprecos.vue?vue&type=template&id=bb436022"
import script from "./tabelasprecos.vue?vue&type=script&lang=js"
export * from "./tabelasprecos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports